import {FooterProps, ShapeType} from "@klear/open-site";

export const footerData: FooterProps = {
        "backgroundShapes": [
            {
                "color": "orange",
                "shapeId": ShapeType.F1,
                "side": "left"
            },
            {
                "color": "blue",
                "shapeId": ShapeType.F2,
                "side": "right"
            },
            {
                "color": "orange",
                "shapeId": ShapeType.F3,
                "side": "right"
            }
        ],
        "columns": [
            {
                "title": "Klear",
                "links": [
                    {
                        "url": "/",
                        "text": "Home"
                    },
                    {
                        "url": "/about",
                        "text": "About"
                    },
                    {
                        "url": "/pricing",
                        "text": "Pricing"
                    },
                    {
                        "url": "/what-is-influence",
                        "text": "What Is Influence"
                    },
                    {
                        "url": "/legal/privacy/",
                        "text": "Legal"
                    },
                    {
                        "url": "/legal/privacy-notice-for-influencers/",
                        "text": "Influencer Notice"
                    },
                    {
                        "url": "/opt-out/",
                        "text": "Opt Out"
                    }
                ]
            },
            {
                "title": "Features",
                "links": [
                    {
                        "url": "/features/find-influencers/",
                        "text": "Find Influencers"
                    },
                    {
                        "url": "/features/influencer-analysis/",
                        "text": "Influencers Analysis"
                    },
                    {
                        "url": "/features/influencer-relationship-management/",
                        "text": "Manage Relationships"
                    },
                    {
                        "url": "/features/activate-influencers/",
                        "text": "Activate Influencers"
                    },
                    {
                        "url": "/features/influencer-program/",
                        "text": "Measure Campaigns"
                    },
                    {
                        "url": "/creators/",
                        "text": "For Influencers"
                    }
                ]
            },
            {
                "title": "Solutions",
                "links": [
                    {
                        "url": "/solutions/instagram-influencers/",
                        "text": "Instagram"
                    },
                    {
                        "url": "/solutions/youtube-influencers/",
                        "text": "YouTube"
                    },
                    {
                        "url": "/solutions/tiktok-influencers/",
                        "text": "TikTok"
                    },
                    {
                        "url": "/solutions/enterprise/",
                        "text": "Enterprise"
                    },
                    {
                        "url": "/solutions/agencies/",
                        "text": "Agency"
                    },
                    {
                        "url": "/solutions/e-commerce/",
                        "text": "E-Commerce"
                    }
                ]
            },
            {
                "title": "Resources",
                "links": [
                    {
                        "url": "/influencer-marketing-guide/",
                        "text": "Guide"
                    },
                    {
                        "url": "/blog/",
                        "text": "Blog"
                    },
                    {
                        "url": "/case-studies/",
                        "text": "Case Studies"
                    }
                ]
            }
        ]
};